import type { FunctionComponent } from "react";
import { RejectPayoutModalPartial } from "../../../../partials/admin/menus/payout/reject-payout-modal.admin.partials";

export const RejectPayoutModalAdminScreen: FunctionComponent = () => {
	return <RejectPayoutModalPartial />;
};
